import React from "react";
import { Link } from "react-router-dom";
import "./cta.css";

const CTASmall = ({ to, text, icon: Icon }) => {
  return (
    <Link to={to} className="cta-fullwidth small-cta">
      <h3 className="cta-text">{text}</h3>
      {Icon && <Icon className="cta-icon" />}
    </Link>
  );
};

export default CTASmall;
 